<template>
    <div>
        <div class="greyBody" id="greyBodyId">
            <div class="greyText1">
              {{ submitTitle }}
            </div>
            <div class="jindutiao">
                <img src="../../assets/countyQB/蓝1.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 265px;width: 30px;height: 30px;">
                <div class="jindutiaoText1">需求确认</div>
                <div class="jindutiaoLine1"></div>
                <img src="../../assets/countyQB/蓝2.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 445px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="color: #3a3a3a;">订单提交</div>
                <div class="jindutiaoText3">{{submitTime}}</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 475px;"></div>
                <img src="../../assets/countyQB/灰3.png" alt="" class="jindutiaoIcon1" style="position: absolute;left: 625px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 602px;">审核与支付</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 655px;"></div>
                <img src="../../assets/countyQB/灰4.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:805px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 782px;">交付</div>
                <div class="jindutiaoLine2" style="width: 150px;left: 835px;"></div>
                <img src="../../assets/countyQB/灰5.png" alt="" class="jindutiaoIcon1" style="position: absolute;left:985px;width: 30px;height: 30px;">
                <div class="jindutiaoText2" style="left: 962px;">评价</div>
            </div>
            <div class="greyWhite">
              <img src="../../assets/countyQB/成功.png" alt="" class="jindutiaoIcon1" style="width:44px;height:44px;display: block">
              <div class="greyWhiteText1">订单提交成功，我们会尽快审核~</div>
              <div class="greyWhiteText2">订单号：<span style="color: #006699;">{{requirementId}}</span></div>

              <!--商务经理企业微信-->
              <img style="width: 87px;height: 87px;margin-top: 30px" src="@/assets/Archive/商务经理企业微信.png">
              <div style="font-size: 14px;color: #000000A6;font-weight: 600;margin: 5px auto 0 auto;width: fit-content" >扫码添加商务经理企业微信</div>

              <div class="greyWhiteText3">我们的商务专员将尽快审核您的订单，请及时关注商城订单状态和短信通知</div>
              <div class="greyWhiteButton" @click="jumpWithPermission('可游客','/store/RsOrderDetail?orderId='+requirementId,'/rskit')">查看订单详情</div>
            </div>
            <div class="greyText2">若您有任何疑问请咨询商务经理：0431-86008580</div>
        </div>
        <div class="footerWhite">
            <div class="text">
                © 2024-2025 长光卫星技术股份有限公司 版权所有 |
                <span @click="goPrivacyPolicy()" style="cursor: pointer">隐私协议</span>
                |
                <span @click="goServiceAgreement()" style="cursor: pointer"
                >服务条款</span
                >
            </div>
        </div>
    </div>
</template>

<script>
import {rootUrl} from '@/globalConfig'
export default {
    name:"demandSubmit",
    data(){
        return{
            submitTime:"",
        }
    },
    computed:{
        requirementId(){
            return this.$route.query.id || "";
        },
        orderScene(){
            return this.$route.query.orderScene || "";
        },
        submitTitle(){
            if(this.orderScene === 'annualPurchase'){
                return '购买图源包年';
            }
            if(this.orderScene === 'generalTraffic'){
                return '购买通用流量';
            }
            return '购买通用流量';
        }
    },
    methods:{
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        goPrivacyPolicy() {
            window.open("http://jl1mall.com/PrivacyPolicy", "_self");
        },
        goServiceAgreement() {
            window.open("http://jl1mall.com/ServiceAgreement", "_self");
        },
        formatNow(){
            const now = new Date();
            const y = now.getFullYear();
            const m = String(now.getMonth() + 1).padStart(2, '0');
            const d = String(now.getDate()).padStart(2, '0');
            const hh = String(now.getHours()).padStart(2, '0');
            const mm = String(now.getMinutes()).padStart(2, '0');
            const ss = String(now.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
        },
        // 获取状态时间信息
        initSubmitTime(){
            if(this.orderScene === 'generalTraffic' || this.orderScene === 'annualPurchase' || this.requireType === 'basic' || this.requireType === 'premium'){
                this.submitTime = this.formatNow();
                return;
            }
            if(!this.requirementId){
                this.submitTime = this.formatNow();
                return;
            }
            this.axios.get("/tilesapi/tiles/county/order/queryCountyOrderByOrderId?orderId=" + this.requirementId, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            }).then((res) => {
                let data = res.data.data || {};
                this.submitTime = data.createTime || this.formatNow();
            }).catch(() => {
                this.submitTime = this.formatNow();
            })

        },
        getHeight(){
            let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            let greyBodyId = document.getElementById("greyBodyId")
            let scrollHeight = greyBodyId.scrollHeight
            if(scrollHeight<windowHeight-196){
              greyBodyId.style.height=windowHeight-196+'px'
            }else{
              greyBodyId.style.height='auto'
            }
        },

    },
    mounted(){
        this.getHeight()
        this.initSubmitTime()
    }

}
</script>

<style scoped>
.greyBody{
    position: relative;
    margin-top: 76px;
    width: 100%;
    height: auto;
    background: #F5F5F6;
    overflow: hidden;
    padding-top: 1px;
    padding-bottom: 1px;
}
.goback{
    position: absolute;
    height: 18px;
    width: 60px;
    top: 62px;
    left: calc(50% - 640px);
    cursor: pointer;
}
.gobackText{
    position: absolute;
    left: 10px;
    width: 50px;
    height: 18px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 18px;
}
.greyText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 200px);
    width: 400px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.jindutiao{
    position: absolute;
    width: 1280px;
    height: 76px;
    top: 142px;
    left: calc(50% - 640px);
}
.jindutiaoText1{
    position: absolute;
    top: 35px;
    left: 242px;
    width: 76px;
height: 16px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 16px;
text-align: center;
}
.jindutiaoLine1{
   position: absolute;
   top: 14px;
   left: 292px;
   width: 155px;
    height: 1px;
    border-top: 2px solid #0066CC;
}
.jindutiaoLine2{
    position: absolute;
    top: 15px;
    left: 370px;
    width: 75px;
    height: 2px;
    border-top: 1px solid #CCCCCC;

}
.jindutiaoText2{
    position: absolute;
    left: 422px;
    top: 35px;
    width: 76px;
    height: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 16px;
    text-align: center;
}
.jindutiaoText3{
    position: absolute;
    left: 387px;
    top: 56px;
    width: 147px;
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 16px;
    text-align: center;

}
.greyWhite{
    position: relative;
    margin-top: 275px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 570px;
    background: #FFFFFF;
    border-radius: 12px;
    overflow: hidden;
    display:flex;justify-content:center;
    align-items:center;flex-direction:column;
}
.greyWhiteText1{
  margin-top: 20px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 28px;
  text-align: center;
}
.greyWhiteText2{
    margin-top: 20px;
    width: 1280px;
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 28px;
    text-align: center;
}
.greyWhiteText3{
    margin-top: 58px;
    width: 1280px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.greyWhiteButton{
    margin-top: 52px;
    width: 150px;
    height: 44px;
    background: #0066CC;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
}
.greyText2{
    margin: 100px auto;
    width: 1280px;
    height: 25px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.footerWhite{
    position: relative;
    width: 100%;
    height: 120px;
    background: #FFFFFF;
}
.text {
  position: absolute;
  top: 50px;
  left: calc(50% - 350px);
  width: 700px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 17px;
  text-align: center;
}
</style>
